import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-setting-home',
  templateUrl: './user-setting-home.component.html',
  styleUrls: ['./user-setting-home.component.scss']
})
export class UserSettingHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
